import { AlertCircle } from "lucide-react";

export const CONTACT_METHODS = ["Phone Call", "Text Message", "Email"] as const;
export type ContactMethod = (typeof CONTACT_METHODS)[number];
export type ContactMethodValue = ContactMethod | "";

export function ContactMethodPicker({
  value,
  onChange,
  error,
}: {
  value: ContactMethodValue;
  onChange: (m: ContactMethod) => void;
  error?: string;
}) {
  const hasError = !!error;
  return (
    <fieldset aria-invalid={hasError || undefined}>
      <legend
        className={`font-display text-xs uppercase tracking-wider ${
          hasError ? "text-red" : "text-navy-deep"
        }`}
      >
        Preferred Contact Method <span aria-hidden="true">*</span>
      </legend>
      <div
        className={`mt-2 flex flex-wrap gap-2 ${
          hasError ? "rounded-sm p-1 ring-2 ring-red/60" : ""
        }`}
        role="radiogroup"
        aria-label="Preferred contact method"
        aria-required="true"
      >
        {CONTACT_METHODS.map((m) => {
          const active = value === m;
          const inactiveBorder = hasError ? "border-red/60" : "border-navy-deep/20";
          return (
            <label
              key={m}
              className={`cursor-pointer border-2 px-4 py-2 font-display text-xs uppercase tracking-wider transition ${
                active
                  ? "border-navy-deep bg-navy-deep text-white"
                  : `${inactiveBorder} bg-white text-navy-deep hover:border-navy-deep`
              }`}
            >
              <input
                type="radio"
                name="contactMethod"
                value={m}
                checked={active}
                onChange={() => onChange(m)}
                className="sr-only"
              />
              {m}
            </label>
          );
        })}
      </div>
      {hasError ? (
        <p role="alert" className="mt-1 flex items-start gap-1 text-xs font-medium text-red">
          <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span>{error}</span>
        </p>
      ) : null}
    </fieldset>
  );
}
